/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Pack_Opener_DescriptionInputs */



/**
* | output |
* | --- |
* | "Simulate opening boosters with real pull rates" |
*
* @param {Nav_Pack_Opener_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_pack_opener_description = /** @type {((inputs?: Nav_Pack_Opener_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Pack_Opener_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Booster mit echten Pull-Raten simuliert öffnen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Simulez l'ouverture de boosters avec les vrais taux")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("用真实出货率模拟开补充包")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("以真實開出率模擬開啟補充包")
	if (locale === "ko") return /** @type {LocalizedString} */ ("실제 출현 확률로 부스터 개봉 시뮬레이션")
	return /** @type {LocalizedString} */ ("Simulate opening boosters with real pull rates")
});